import React, { useState, useEffect } from 'react';
import { FaCog, FaMoneyBill, FaUsers, FaUserShield, FaClipboardList, FaFileAlt, FaCity, FaBell, FaTable, FaMapMarker, FaPaypal } from 'react-icons/fa';
import { GiPayMoney } from 'react-icons/gi';
import { IoMdHome, IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { IoSettings, IoNotifications } from 'react-icons/io5';
import { MdVerifiedUser } from 'react-icons/md';
import { BsFileEarmarkText } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';

const MenuItem = ({ item, show, isExpanded, toggleExpand, navigate, activeRoute, closeMobileSidebar }) => {
  const hasSubItems = item.subItems && item.subItems.length > 0;
  const isActive = activeRoute === item.path;
  const isParentActive = hasSubItems && item.subItems.some(subItem => activeRoute === subItem.path);

  const handleClick = () => {
    if (hasSubItems) {
      toggleExpand(item.title);
    }
  };

  return (
    <div className="text-blue-100">
      <div
        className={`
          flex items-center p-4 cursor-pointer transition-all duration-200
          ${hasSubItems ? 'hover:bg-blue-700' : ''}
          ${isActive ? 'bg-blue-600 border-l-4 border-blue-100' : 'hover:bg-blue-600'}
        `}
        onClick={handleClick}
      >
        <item.icon 
          className={`flex-shrink-0 ${isActive ? 'text-blue-300' : 'text-blue-200'}`} 
          size={20} 
        />
        {show && (
          <>
            <Link
              to={item.path || '#'}
              className={`ml-3 flex-grow ${isActive ? 'text-white font-semibold' : ''}`}
              onClick={closeMobileSidebar}
            >
              {item.title}
            </Link>
            {hasSubItems && (
              <div className="ml-4">
                {isExpanded ? (
                  <IoIosArrowDown size={16} className="text-blue-200" />
                ) : (
                  <IoIosArrowForward size={16} className="text-blue-200" />
                )}
              </div>
            )}
          </>
        )}
      </div>

      {hasSubItems && isExpanded && show && (
        <div className="ml-8 border-l border-blue-600">
          {item.subItems.map((subItem, index) => (
            <Link
              key={index}
              to={subItem.path}
              className={`
                flex items-center p-3 cursor-pointer transition-all duration-200
                ${activeRoute === subItem.path ? 'bg-blue-700 border-l-4 border-blue-400' : 'hover:bg-blue-600'}
              `}
              onClick={closeMobileSidebar}
            >
              <subItem.icon 
                className={`flex-shrink-0 ${activeRoute === subItem.path ? 'text-blue-400' : 'text-blue-200'}`} 
                size={16} 
              />
              <span className={`ml-3 ${activeRoute === subItem.path ? 'text-white font-semibold' : ''}`}>
                {subItem.title}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};


const Sidebar = ({ show = true, setSidebar, mobileSidebar, closeMobileSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState(new Set());

  const toggleExpand = (menuTitle) => {
    setExpandedMenus(prev => {
      const newSet = new Set(prev);
      if (newSet.has(menuTitle)) {
        newSet.delete(menuTitle);
      } else {
        newSet.add(menuTitle);
      }
      return newSet;
    });
  };

  const menuItems = [
    { 
      title: 'Dashboard', 
      path: '/dashboard', 
      icon: IoMdHome 
    },
    {
      title: 'Admin',
      icon: FaUserShield,
      subItems: [
        { 
          title: 'Admin', 
          path: '/admin', 
          icon: FaUserShield 
        },
        { 
          title: 'Roles', 
          path: '/roles', 
          icon: FaUserShield 
        }
      ]
    },
    { 
      title: 'Customers', 
      path: '/customers', 
      icon: FaUsers
    },
    {
      title: 'Loans',
      icon: GiPayMoney,
      subItems: [
        { 
          title: 'Review Loans', 
          path: '/reviewLoans', 
          icon: FaMoneyBill 
        },
        { 
          title: 'Pending Loans', 
          path: '/pendingLoans', 
          icon: FaMoneyBill 
        },
        { 
          title: 'Disbursed Loans', 
          path: '/disbursedLoans', 
          icon: GiPayMoney 
        },
       
        { 
          title: 'Applications', 
          path: '/loan-applications?type=all', 
          icon: FaMoneyBill 
        },
        { 
          title: 'All Loans', 
          path: '/loans', 
          icon: GiPayMoney 
        },
     
     
      ]
    },
    { 
      title: 'Emis', 
      path: '/emilist', 
      icon: FaPaypal
    },
  

    {
      title: 'Config',
      icon: FaCog,
      subItems: [
        { 
          title: 'Setting', 
          path: '/settings', 
          icon: IoSettings 
        },
        { 
          title: 'Feature Configuration', 
          path: '/featureConfigs', 
          icon: FaCog 
        },
        { 
          title: 'Secret', 
          path: '/secrets', 
          icon: FaCog 
        },
        { 
          title: 'Loan Terms', 
          path: '/loanTerms', 
          icon: FaTable
        },{
          title: 'Version',
          path: '/apiVersions',
          icon: FaMapMarker
        
        }
        
      ]
    },
    {
      title: 'Service Area',
      icon: FaCity,
 
      path: '/serviceArea', 
         
     
      
    },
    {
      title: 'Notiffication Template',
      icon: FaBell,
 
      path: '/notifficationTemplate', 
         
     
      
    },
    {
      title: 'Logs',
      icon: FaClipboardList,
      subItems: [
        { 
          title: 'API Logs', 
          path: '/apiLogs', 
          icon: FaFileAlt 
        },
      ]
    }
  ];

  useEffect(() => {
    const activeMenuItem = menuItems.find(item => 
      item.path === location.pathname || 
      (item.subItems && item.subItems.some(subItem => subItem.path === location.pathname))
    );

    if (activeMenuItem && activeMenuItem.subItems) {
      setExpandedMenus(prev => new Set(prev).add(activeMenuItem.title));
    }
  }, [location.pathname]);

  return (
    <div className={`
      bg-blue-800 min-h-screen max-h-screen 
      ${mobileSidebar ? 'w-64' : show ? 'w-64' : 'w-20'} 
      transition-all duration-300 overflow-y-auto
    `}>
      <div className="p-4">
        <h1 className={`text-xl font-bold text-white  ${!show && 'hidden'}`}>
        KredTap
        </h1>
      </div>
      <div className="mt-4">
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            item={item}
            show={show}
            isExpanded={expandedMenus.has(item.title)}
            toggleExpand={toggleExpand}
            navigate={navigate}
            activeRoute={location.pathname}
            closeMobileSidebar={closeMobileSidebar}
          />
        ))}
      </div>
    </div>
  );
};

export default Sidebar;

